import { gql } from '@apollo/client';

export const CREATE_USER_ID_VERIFICATION_INFORMATION = gql`
  mutation createUserIDVerificationInformation(
    $input: CreateUserIDVerificationInformationInput!
  ) {
    createUserIDVerificationInformation(input: $input) {
      idVerification {
        id
      }
    }
  }
`;
